// src/serviceWorkerRegistration.js
// Registro del Service Worker para CRA con detección de actualizaciones.
// Basado en el template oficial de Create React App 5.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

let recargandoPorCambioDeVersion = false;

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // Las reglas de seguridad y el frontend se despliegan juntos. Cuando el
    // worker nuevo toma el control, recargar evita que una pestaña antigua
    // intente escribir con un contrato que las reglas ya no aceptan.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (recargandoPorCambioDeVersion) return;
      recargandoPorCambioDeVersion = true;
      window.location.reload();
    });

    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost: verificar si el SW existe
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('[SW] App servida cache-first por el service worker.');
        });
      } else {
        // Producción: registrar directamente
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // ✅ Revisar actualizaciones cada 60 segundos (no solo al abrir)
      setInterval(() => {
        registration.update();
      }, 60 * 1000);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // ✅ Hay una versión nueva lista — notificar al usuario
              console.log('[SW] Nueva versión disponible. Mostrando aviso...');

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Primera instalación — contenido cacheado para offline
              console.log('[SW] Contenido cacheado para uso offline.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[SW] Error durante el registro:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // SW no encontrado — probablemente otra app. Desregistrar y recargar.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[SW] Sin conexión. App funcionando en modo offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
